export default class DeletePathResult {

    Id: number;

    constructor(id: number) {
        this.Id = id;
    }
}
